import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useState } from "react";
var defaultContext = {
    lastCreatedResource: null,
    setLastCreatedResource: function () { return undefined; },
};
export var NewResourceContext = createContext(defaultContext);
export default function NewResourceContextProvider(_a) {
    var children = _a.children;
    var _b = useState(null), lastCreatedResource = _b[0], setLastCreatedResource = _b[1];
    return (_jsx(NewResourceContext.Provider, { value: {
            lastCreatedResource: lastCreatedResource,
            setLastCreatedResource: setLastCreatedResource,
        }, children: children }));
}
